var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visa-icono"},[_c('div',{staticClass:"icono rc-shadow"},[_c('img',{attrs:{"src":_vm.imgIcono,"alt":_vm.tituloIcono}})]),_c('div',{staticClass:"texto"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.textIcono)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }